import axios from "axios";

const configuredApiBaseUrl = (process.env.VUE_APP_API_BASE_URL || "")
  .trim()
  .replace(/\/+$/, "");

const API_BASE_URL = configuredApiBaseUrl || (
  process.env.NODE_ENV === "development"
    ? "https://localhost:7204"
    : ""
);

const refreshRequest = () => axios.post(
  `${API_BASE_URL}/api/auths/refresh`,
  null,
  { withCredentials: true }
);

export function refreshSession() {
  if (typeof navigator !== "undefined" && navigator.locks?.request) {
    return navigator.locks.request(
      "noverand-auth-refresh",
      { mode: "exclusive" },
      refreshRequest
    );
  }

  return refreshRequest();
}
